import store from '../store/Store';
import BookingPrivacyType from '../store/schema/BookingPrivacyType';
/**
 * Util to get published status of the booking page from store.
 */
export default function getEditStatePrivacyType(): boolean {
    const isInviteOnly =
        store.meetingTypeEditState.privacyType == BookingPrivacyType.PrivateMeetingType;
    return isInviteOnly;
}
